module.exports = {"Basic":{"SideName":"繁体字百应钱包","BTC":"比特幣"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/locales/lang/zh-TW.json
// module id = ibDn
// module chunks = 1